import {
  GET_USER_PROFILE,
  SET_AUTH,
  SET_EDITOR_AUTH,
  SENDING_LOGIN_REQUEST,
  STATUSES,
  RESET_AUTH,
} from "actions/ActionTypes";

import auth from "utils/Auth";
import { hasRole } from "utils/data/User";
import { MODERATOR } from "../constants/roles";

const initialState = {
  authentication_data: "",
  isLoggedIn: auth.loggedIn(),
  isFetching: false,
  isFetched: false,
  message: "",
  token: auth.getToken(),
  locale: "",
  last_name: "",
  first_name: "",
  email: "",
  organization_uuid: "",
  avatar_url: auth.getAvatar(),
  isEditorAuth: auth.editorAuth(),
  isModerator: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_PROFILE:
      if (action.status === STATUSES.SUCCESSFUL) {
        if (action.params.authentication === "2fa") {
          return {
            authentication_data: action.params.authentication_data || "",
            isLoggedIn: false,
            isFetched: true,
          };
        }
        const user = {
          token: action.params.token || "",
          locale: action.params.locale || "",
          last_name: action.params.last_name || "",
          first_name: action.params.first_name || "",
          email: action.params.email || "",
          avatar_url: action.params.avatar_url || "",
          organization_uuid: action.params.organization_uuid || "",
          isModerator: hasRole(action.params.roles, MODERATOR),
        };

        return {
          ...state,
          ...user,
          isFetched: true,
        };
      }
      return state;
    case SET_AUTH:
      return {
        ...state,
        isLoggedIn: action.loggedIn,
        message: action.message || "",
      };
    case SET_EDITOR_AUTH:
      return {
        ...state,
        isEditorAuth: action.editorAuth,
        organization_uuid: action.organization_uuid || "",
      };
    case SENDING_LOGIN_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    case RESET_AUTH:
      return {
        ...state,
        isLoggedIn: false,
      };
    default:
      return state;
  }
};
